import type { ANNAnnotationRecord } from "./ANNTypes";

export interface ServitutLike {
   dokumentId?: string;
   aktAliasId?: string;
   aktId?: string;
   datoloebenr?: string;
   tekster?: string[];
   tekstSummarisk?: string;
   dokumentFilnavn?: string;
   prioritetNummer?: string | number;
}

export interface NormalizedServitutIdentity {
   documentId: string;
   aktAliasId?: string;
   aktId?: string;
   datoloebenr?: string;
}

export function datoloebenrToAktAliasId(value?: string): string | undefined {
   const trimmed = value?.trim();
   if (!trimmed) {
      return undefined;
   }
   const match = trimmed.match(/^(\d{2})(\d{2})(\d{4})-(.+)$/);
   if (!match) {
      return trimmed;
   }
   return `${match[3]}${match[2]}${match[1]}-${match[4]}`;
}

export function aktAliasIdToDatoloebenr(value?: string): string | undefined {
   const trimmed = value?.trim();
   if (!trimmed) {
      return undefined;
   }
   const match = trimmed.match(/^(\d{4})(\d{2})(\d{2})-(.+)$/);
   if (!match) {
      return trimmed;
   }
   return `${match[3]}${match[2]}${match[1]}-${match[4]}`;
}

export function normalizeServitutIdentity(input?: ServitutLike | ANNAnnotationRecord | string | null): NormalizedServitutIdentity {
   if (typeof input === "string") {
      return { documentId: input, aktId: input };
   }
   const source = input || {};
   const annotation = source as ANNAnnotationRecord;
   const servitut = source as ServitutLike;
   const datoloebenr = annotation.datoloebenr || servitut.datoloebenr || aktAliasIdToDatoloebenr(servitut.aktAliasId || servitut.aktId);
   const aktAliasId = servitut.aktAliasId || datoloebenrToAktAliasId(datoloebenr) || annotation.documentId || servitut.dokumentId || servitut.aktId;
   const documentId = annotation.documentId || servitut.dokumentId || aktAliasId || servitut.aktId || "";
   return {
      documentId,
      aktAliasId,
      aktId: servitut.aktId || documentId,
      datoloebenr,
   };
}

export function buildServitutDetailsParams(
   servitutInput?: ServitutLike | ANNAnnotationRecord | string | null,
   extra?: Record<string, unknown>
) {
   const identity = normalizeServitutIdentity(servitutInput);
   const base = typeof servitutInput === "object" && servitutInput
      ? { ...(servitutInput as ServitutLike) }
      : {};
   const servitut = {
      ...base,
      dokumentId: identity.documentId,
      aktAliasId: identity.aktAliasId,
      aktId: identity.aktId,
      prioritetNummer: base.prioritetNummer || "",
      tekstSummarisk: base.tekstSummarisk || "",
      tekster: base.tekster || [],
      dokumentFilnavn: base.dokumentFilnavn || "",
   };
   return {
      ...extra,
      servitut,
      annotationDocumentId: identity.documentId,
      datoloebenr: identity.datoloebenr,
   };
}
